module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view__tabs"
  }, [_c('ul', {
    staticClass: "view__tabs--menu"
  }, [_c('li', {
    class: _vm.getCssClass('account')
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'account'
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.L.localize('Account_Breadcrumb')) + "\n            ")])], 1), _vm._v(" "), _c('li', {
    class: _vm.getCssClass(['users', 'user', 'user-create'])
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.L.localize('Users_Breadcrumb_Index')) + "\n            ")])], 1), _vm._v(" "), _c('li', {
    class: _vm.getCssClass('webhook')
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'webhook'
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.L.localize('Webhook_Breadcrumb_Index')) + "\n            ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d79172a!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/account/Submenu.vue
// module id = 705
// module chunks = 1